import { Fragment } from "react";
import { Disclosure } from "@headlessui/react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import { Link } from "react-router-dom";
import { logout } from "../services/Requests";

const navigation = [
  { name: "Tasks", href: "/tasks" },
  { name: "Add Task", href: "/add-task" },
  { name: "Login", href: "/" },
  { name: "Register", href: "/register" },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function Navbar() {
  function getNavigationMenu() {
    const token = localStorage.getItem("token");
    return navigation.map(function (item) {
      if ((item.name === "Login" || item.name === "Register") && token) {
        return null;
      } else if (
        (item.name === "Tasks" || item.name === "Add Task") &&
        !token
      ) {
        return null;
      }
      return (
        <Link
          key={item.name}
          to={item.href}
          className={classNames(
            item.href === window.location.pathname
              ? "bg-gray-900 text-white"
              : "text-gray-300 hover:bg-gray-700 hover:text-white",
            "block rounded-md px-3 py-2 text-base font-medium"
          )}
          aria-current={
            item.href === window.location.pathname ? "page" : undefined
          }
        >
          {item.name}
        </Link>
      );
    });
  }

  function getLogoutLink() {
    if (localStorage.getItem("token")) {
      return (
        <Link
          key="Logout"
          className={classNames(
            "text-gray-300 hover:bg-gray-700 hover:text-white",
            "block rounded-md px-3 py-2 text-base font-medium"
          )}
          onClick={logout}
        >
          Logout
        </Link>
      );
    }
  }

  return (
    <Disclosure as="nav" className="bg-gray-800">
      {({ open }) => (
        <>
          <div className="mx-auto max-w-7xl px-2 sm:px-6 lg:px-8">
            <div className="relative flex h-16 items-center justify-between">
              <div className="absolute inset-y-0 left-0 flex items-center sm:hidden">
                {/* Mobile menu button*/}
                <Disclosure.Button className="inline-flex items-center justify-center rounded-md p-2 text-gray-400 hover:bg-gray-700 hover:text-white focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white">
                  <span className="sr-only">Open main menu</span>
                  {open ? (
                    <XMarkIcon className="block h-6 w-6" aria-hidden="true" />
                  ) : (
                    <Bars3Icon className="block h-6 w-6" aria-hidden="true" />
                  )}
                </Disclosure.Button>
              </div>
              <div className="flex flex-1 items-center justify-center sm:items-stretch sm:justify-start">
                <div className="hidden sm:ml-6 sm:block">
                  <div className="flex space-x-4">
                    {getNavigationMenu()}
                    {getLogoutLink()}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <Disclosure.Panel className="sm:hidden">
            <div className="space-y-1 px-2 pb-3 pt-2">
              {getNavigationMenu()}
              {getLogoutLink()}
            </div>
          </Disclosure.Panel>
        </>
      )}
    </Disclosure>
  );
}
